import { Button, Input, Form, Row, Col, Select, message } from "antd/lib";
import { useSelector, useDispatch } from "react-redux";
import React, { useEffect, useState } from "react";
import axiosInPosp from "../../Redux/axios/AxiosInPosp";

export function PaymentLinkPosp() {
  const ViewSingleQuote = useSelector((state) => state?.posp?.PospViewQuote);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [SearchData, setSearchData] = useState([]);
  const [SearchLoading, setSearchLoading] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [clearLoad, setClearLoad] = useState(false);
  const [Placetxt, setplaceHolder] = useState("Enter");

  console.log("ViewSingleQuote-payment", ViewSingleQuote);

  const OnSendLink = (values) => {
    setLoading(true);
    console.log(values);
    const Post = {
      mobile_or_email: values?.mob_mail,
    };
    const formData = new FormData();
    Object.keys(Post).forEach((key) => {
      formData.append(key, Post[key]);
    });
    axiosInPosp
      .post(
        `v1/posp/quick_quotes/${ViewSingleQuote?.id}/payment_link`,
        formData
      )
      .then((res) => {
        console.log(res);
        let sData = res?.data;
        console.log("sData", sData);
        // setSearchData(sData);
        setSearchLoading(true);
        setLoading(false);
        // form.resetFields();
        message.success(sData?.message);
      })
      .catch((err) => {
        console.log(err?.response);
        setLoading(false);
      });
  };
  const onClear = (value) => {
    setClearLoad(true);
    console.log(value);
    setTimeout(() => {
      setSearchData([]);
      form.resetFields();
      setClearLoad(false);
      setSearchLoading(false);
    }, 1000);
  };

  const onValuesChange = (changedValues, allValues) => {
    console.log(allValues);
    const selectSearchValue = allValues.select_search;
    if (selectSearchValue === "Email") {
      setplaceHolder("Enter Email");
    } else if (selectSearchValue === "Mobile No") {
      setplaceHolder("Enter Mobile No");
    }
  };

  return (
    <div>
      <div className="bpodoc-detail">Send Payment Link to Customer</div>
      <Form
        form={form}
        style={{ width: "100%" }}
        requiredMark={false}
        onFinish={OnSendLink}
        onValuesChange={onValuesChange}
      >
        <Row gutter={24} className="justify-content-between">
          <Col span={8}>
            <Form.Item
              name="select_search"
              className="mb-0"
              rules={[
                {
                  required: true,
                  message: "Please Select to search",
                },
              ]}
            >
              <Select
                placeholder="Select"
                style={{
                  width: "100%",
                }}
                options={[
                  {
                    value: "Mobile No",
                    label: "Mobile No",
                  },
                  {
                    value: "Email",
                    label: "Email",
                  },
                ]}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="mob_mail"
              className="mb-0"
              rules={[
                {
                  required: true,
                  message: "Input Valid data",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const selectSearchValue = getFieldValue("select_search");
                    if (selectSearchValue === "Email") {
                      setplaceHolder("Enter Email");
                      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject("Invalid Email");
                      }
                    } else if (selectSearchValue === "Mobile No") {
                      if (/^([0|+[0-9]{1,5})?([6-9][0-9]{9})$/.test(value)) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject("Invalid Mobile No");
                      }
                    } else {
                      return Promise.resolve();
                    }
                  },
                }),
              ]}
            >
              <Input
                style={{ width: "100%", padding: "2px 8px" }}
                placeholder={Placetxt}
                // onChange={handleInputChange}
              />
            </Form.Item>
          </Col>
          {SearchLoading === true ? (
            <Col span={4}>
              <Form.Item className="mb-0">
                <Button
                  loading={clearLoad}
                  onClick={onClear}
                  style={{
                    backgroundColor: "#3097DE",
                    border: "#3097DE",
                    color: "white",
                    padding: "0px 6px;",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  Clear
                </Button>
              </Form.Item>
            </Col>
          ) : (
            <Col span={4}>
              <Form.Item className="mb-0">
                <Button
                  loading={Loading}
                  htmlType="submit"
                  style={{
                    backgroundColor: "#3097DE",
                    border: "#3097DE",
                    color: "white",
                    padding: "0px 6px;",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  Send
                </Button>
              </Form.Item>
            </Col>
          )}
        </Row>
      </Form>
    </div>
  );
}
